import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
export function column(value, field) {
  if (value === null) return undefined;
  return {
    type: 'column',
    value: value,
    field: field
  };
}
export function inferredColumn(value, field) {
  var c = column(value, field);
  return Object.assign(Object.assign({}, c), {
    inferred: true
  });
}
export function visualColumn(value, field) {
  if (value === null) return undefined;
  return {
    type: 'column',
    value: value,
    field: field,
    visual: true
  };
}
export function nonConstantColumn(value, field) {
  var c = column(value, field);
  return Object.assign(Object.assign({}, c), {
    constant: false
  });
}
export function constant(I, value) {
  var array = [];
  var _iterator = _createForOfIteratorHelper(I),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var i = _step.value;
      array[i] = value;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return array;
}
export function columnOf(encode, key) {
  var channel = encode[key];
  if (!channel) return [null, null];
  var value = channel.value,
    _channel$field = channel.field,
    field = _channel$field === void 0 ? null : _channel$field;
  return [value, field];
}
export function maybeColumnOf(encode) {
  for (var _len = arguments.length, K = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    K[_key - 1] = arguments[_key];
  }
  for (var _i = 0, _K = K; _i < _K.length; _i++) {
    var key = _K[_i];
    if (typeof key === 'string') {
      var _columnOf = columnOf(encode, key),
        _columnOf2 = _slicedToArray(_columnOf, 2),
        KV = _columnOf2[0],
        fv = _columnOf2[1];
      if (KV !== null) return [KV, fv];
    } else {
      return [key, null];
    }
  }
  return [null, null];
}
export function isObject(d) {
  if (d instanceof Date) return false;
  return typeof d === 'object';
}